import { type TTranscodingSimple as TApiTranscodingSimple } from '@core/api'

import { type TAudioFileTranscodingSimple } from '@core/models'

export const convertAudioTranscodingSimple = (
    apiTranscodingSimple: TApiTranscodingSimple,
): TAudioFileTranscodingSimple => {
    const { id, source_id, format, url, waveform, duration, version } = apiTranscodingSimple

    return {
        id,
        sourceId: source_id,
        format,
        url,
        waveform,
        duration,
        version,
    }
}
